import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const FormSection = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={css`
				margin: 32px 0;
			`}
		>
			{children}
		</div>
	);
};
